import {useTranslation} from "react-i18next";

export const PostSource = ({source})=>{
  const { t } = useTranslation();
    return <div>
        <div className={'pictoSource'}></div>
        <span>{t('Source')}: </span>
        <a target={"_blank"} rel="noreferrer" href={source.url}>{source.name}</a>
    </div>
}
